import { FlattenedStrapiObj, StrapiObj } from "../api/models.types";

export function flatData <T>(data:StrapiObj<T>[]) {
    return data?.map(x => ({
            id: x?.id,
            ...x.attributes
    })) as FlattenedStrapiObj<T>[]
}
